import styled from "@emotion/styled";
import { Breakpoints, Transitions } from "../assets/variables/variables";

export const Flex = styled.div`
  display: flex;
`;

export const Block = styled.div`
  display: inline-block;
  position: relative;
`;

export const Container = styled.div`
  max-width: 1310px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media only screen and (max-width: ${Breakpoints.$large}) {
    max-width: ${Breakpoints.$medium};
  }

  @media only screen and (max-width: ${Breakpoints.$medium}) {
    max-width: ${Breakpoints.$small};
  }

  @media only screen and (max-width: ${Breakpoints.$small}) {
    max-width: ${Breakpoints.$extraSmall};
  }
`;

export const DivHalf = styled.div`
  position: relative;
  display: inline-block;
  width: 50%;
`;

export const Row = styled.div`
  display: flex;
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const CloseBtn = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: relative;

  &:before,
  &:after {
    position: absolute;
    content: "";
    width: 35px;
    height: 2px;
    top: 13px;
    left: -3px;
    background-color: #000;
  }

  &:before {
    transform: rotate(-45deg);
  }

  &:after {
    transform: rotate(45deg);
  }
`;

export const PageTransition = styled.div`
  position: relative;
  opacity: 0;
  transform: translateX(-100px);
  transition: 0.3s ${Transitions.$superSmooth};

  &.active {
    opacity: 1;
    transform: translateX(0);
  }
`;
